// import React from "react";
// import MainDashboard from "./Screens/Admin/Dashboard/Dashboard";
// import SignIn from "./Screens/Auth/SignIn";
// import { RiContactsBookFill } from "react-icons/ri";
// import { PromoCodeUsage } from "Screens/Admin/Promocode/PromoCodeUsage";
// import { FaUsers } from "react-icons/fa6";
// import { BiSolidCoupon } from "react-icons/bi";
// import { MdNotificationsActive } from "react-icons/md";
// import { MdSpaceDashboard } from "react-icons/md";
// import Traffic from "Screens/Admin/Traffic/Traffic";
// import ManagePromoCode from "Screens/Admin/Promocode/ManagePromoCode";
// import Users from "Screens/Admin/Users";
// import Coins from "Screens/Admin/Gifts_&_Coins/Coins";
// import Gifts from "Screens/Admin/Gifts_&_Coins/Gifts";
// import AccountDeleteReq from "Screens/Admin/AccountDeleteReq";
// import BlockUser from "Screens/Admin/BulkNotification/BlockUser";
// import Banner from "Screens/Admin/BulkNotification/Banner";
// import UserDetailsPage from "Screens/Admin/UserDetailsPage";
// import AdminProfilesDetails from "Screens/Admin/AdminProfilesDetails";
// import { GiMoneyStack } from "react-icons/gi";
// import ContactUs from "Screens/Admin/ContactUs/ContactUs";
// import GroupRequest from "Screens/Admin/GroupRequest";
// import CallHistories from "Screens/Admin/CallHistories/CallHistories";
// import CoinHistories from "Screens/Admin/CoinHistories/CoinHistories";
// import Avatar from "Screens/Admin/Avatar/Avatar";
// import NameChangeReq from "Screens/Admin/NameChange/NameChangeReq";
// import Approve from "Screens/Admin/Payout/Approve";
// import WithdrawalRequest from "Screens/Admin/Payout/WithdrawalRequest";
// import { VscRequestChanges } from "react-icons/vsc";
// import Kyc from "Screens/Admin/Payout/Kyc";
// import ManualWithdrawal from "Screens/Admin/Payout/ManualWithdrawal";
// import Recharge from "Screens/Admin/Recharge/Recharge";
// import StaffDashboard from "Screens/Admin/StaffDashboard/StaffDashboard";
// import { GrUserWorker } from "react-icons/gr";
// import Role from "Screens/Admin/RolePermission/Role";

// const routes = [
//   // 1. Dashboard
//   {
//     name: "Dashboard",
//     showInSidebar: true,
//     layout: "/admin",
//     path: "dashboard",
//     icon: <MdSpaceDashboard className="h-6 w-6" />,
//     component: <MainDashboard />,
//     clickable: true,
//     permissionKey: "dashboard",
//   },

//   {
//     name: "Role",
//     showInSidebar: true,
//     layout: "/admin",
//     path: "role",
//     icon: <GrUserWorker className="h-6 w-6" />,
//     component: <Role />,
//     clickable: true,
//     permissionKey: "roleManagement",
//   },

//   {
//     name: "Staffs",
//     showInSidebar: true,
//     layout: "/admin",
//     path: "staff-dashboard",
//     icon: <GrUserWorker className="h-6 w-6" />,
//     component: <StaffDashboard />,
//     clickable: true,
//     permissionKey: "staffManagement",
//   },

//   // 2. users
//   {
//     name: "Users",
//     showInSidebar: true,
//     layout: "/admin",
//     findPath: "users",
//     icon: <FaUsers className="h-6 w-6" />,
//     clickable: false,
//     permissionKey: "users",
//     children: [
//       {
//         name: "User ",
//         nestedFindPath: "user",
//         layout: "/admin",
//         path: "users/user",
//         component: <Users />,
//         permissionKey: "users.user",
//       },
//       {
//         name: "Traffic",
//         nestedFindPath: "traffic",
//         layout: "/admin",
//         path: "users/traffic",
//         component: <Traffic />,
//         permissionKey: "users.Traffic",
//       },
//       {
//         name: "Call History",
//         nestedFindPath: "call-history",
//         layout: "/admin",
//         path: "users/call-history",
//         component: <CallHistories />,
//         permissionKey: "users.CallHistory",
//       },
//       {
//         name: "Coin History",
//         nestedFindPath: "coin-histories",
//         layout: "/admin",
//         path: "users/coin-histories",
//         component: <CoinHistories />,
//         permissionKey: "users.CoinHistory",
//       },
//       {
//         name: "Recharge",
//         nestedFindPath: "recharge",
//         layout: "/admin",
//         path: "users/recharge",
//         component: <Recharge />,
//         permissionKey: "users.Recharge",
//       },
//       {
//         name: "Avatar",
//         nestedFindPath: "avatar",
//         layout: "/admin",
//         path: "users/avatar",
//         component: <Avatar />,
//         permissionKey: "users.Avatar",
//       },
//       {
//         name: "BlockUser",
//         nestedFindPath: "blockUser",
//         layout: "/admin",
//         path: "users/blockUser",
//         component: <BlockUser />,
//         permissionKey: "users.BlockUser",
//       },
//     ],
//   },

//   // Pay Out
//   {
//     name: "Pay Out",
//     showInSidebar: true,
//     layout: "/admin",
//     findPath: "payout",
//     icon: <GiMoneyStack className="h-6 w-6" />,
//     clickable: false,
//     permissionKey: "payout",
//     children: [
//       {
//         name: "KYC",
//         nestedFindPath: "kyc",
//         layout: "/admin",
//         path: "payout/kyc",
//         component: <Kyc />,
//         permissionKey: "payout.kyc",
//       },
//       {
//         name: "Approve",
//         nestedFindPath: "approve",
//         layout: "/admin",
//         path: "payout/approve",
//         component: <Approve />,
//         permissionKey: "payout.approve",
//       },
//       {
//         name: "Wallet",
//         nestedFindPath: "wallet",
//         layout: "/admin",
//         path: "payout/wallet",
//         component: <WithdrawalRequest />,
//         permissionKey: "payout.wallet",
//       },
//       {
//         name: "Manual Withdrawal",
//         nestedFindPath: "manual-withdrawal",
//         layout: "/admin",
//         path: "payout/manual-withdrawal",
//         component: <ManualWithdrawal />,
//         permissionKey: "payout.manualWithdrawal",
//       },
//     ],
//   },

//   // Coin Management
//   {
//     name: "Coin Management",
//     showInSidebar: true,
//     findPath: "coin-management",
//     layout: "/admin",
//     icon: <BiSolidCoupon className="h-6 w-6" />,
//     clickable: false,
//     permissionKey: "coinManagement",
//     children: [
//       {
//         name: "Manage Coins",
//         nestedFindPath: "manage-coins",
//         layout: "/admin",
//         path: "coin-management/manage-coins",
//         component: <Coins />,
//         permissionKey: "coinManagement.manageCoins",
//       },
//       {
//         name: "Manage Emoji Gifts",
//         nestedFindPath: "manage-gifts",
//         layout: "/admin",
//         path: "coin-management/manage-gifts",
//         component: <Gifts />,
//         permissionKey: "coinManagement.manageGifts",
//       },
//       {
//         name: "Promo Code",
//         nestedFindPath: "promocode",
//         layout: "/admin",
//         path: "coin-management/promocode",
//         component: <ManagePromoCode />,
//         permissionKey: "coinManagement.promocode",
//       },
//       {
//         name: "Coin Promocode",
//         layout: "/admin",
//         path: "coin-management/promo-code-usage",
//         component: <PromoCodeUsage />,
//         permissionKey: "coinManagement.coinPromocode",
//       },
//     ],
//   },

//   // Notification
//   {
//     name: "Notification",
//     showInSidebar: true,
//     findPath: "notification",
//     layout: "/admin",
//     icon: <MdNotificationsActive className="h-6 w-6" />,
//     clickable: false,
//     permissionKey: "Notifications",
//     children: [
//       {
//         name: "Single",
//         nestedFindPath: "single",
//         layout: "/admin",
//         path: "notification/single",
//         permissionKey: "Notifications.single",
//       },
//       {
//         name: "Bulk",
//         nestedFindPath: "bulk",
//         layout: "/admin",
//         path: "notification/bulk",
//         permissionKey: "Notifications.bulk",
//       },
//       {
//         name: "Banner",
//         nestedFindPath: "banner",
//         layout: "/admin",
//         path: "notification/banner",
//         component: <Banner />,
//         permissionKey: "Notifications.banner",
//       },
//     ],
//   },

//   // User Request
//   {
//     name: "User Request",
//     showInSidebar: true,
//     findPath: "user-request",
//     layout: "/admin",
//     icon: <VscRequestChanges className="h-6 w-6" />,
//     clickable: false,
//     permissionKey: "userRequests",
//     children: [
//       {
//         name: "Account Delete Req",
//         nestedFindPath: "acc-delete-req",
//         layout: "/admin",
//         path: "user-request/acc-delete-req",
//         component: <AccountDeleteReq />,
//         permissionKey: "userRequests.accDeleteReq",
//       },
//       {
//         name: "Group Request",
//         nestedFindPath: "group-request",
//         layout: "/admin",
//         path: "user-request/group-request",
//         component: <GroupRequest />,
//         permissionKey: "userRequests.groupReq",
//       },
//       {
//         name: "Name Change Req",
//         nestedFindPath: "name-change-req",
//         layout: "/admin",
//         path: "user-request/name-change-req",
//         component: <NameChangeReq />,
//         permissionKey: "userRequests.nameChangeReq",
//       },
//     ],
//   },

//   {
//     name: "App Feedback",
//     showInSidebar: true,
//     layout: "/admin",
//     path: "contact-us",
//     icon: <RiContactsBookFill className="h-6 w-6" />,
//     component: <ContactUs />,
//     clickable: true,
//     permissionKey: "appFeedback",
//   },

//   // hidden routes (no sidebar)
//   {
//     name: "User Details",
//     showInSidebar: false,
//     layout: "/admin",
//     path: "users/user-details/:id",
//     component: <UserDetailsPage />,
//     permissionKey: "user-details",
//   },
//   {
//     name: "Admin Profile",
//     showInSidebar: false,
//     layout: "/admin",
//     path: "my-profile",
//     component: <AdminProfilesDetails />,
//     permissionKey: "admin-profiles-details",
//   },

//   // Auth
//   {
//     name: "Sign In",
//     layout: "/auth",
//     path: "sign-in",
//     component: <SignIn />,
//     permissionKey: "sign-in",
//   },
// ];

// export default routes;

import React from "react";
import MainDashboard from "./Screens/Admin/Dashboard/Dashboard";
import SignIn from "./Screens/Auth/SignIn";
import { RiContactsBookFill } from "react-icons/ri";
import { PromoCodeUsage } from "Screens/Admin/Promocode/PromoCodeUsage";
import { FaUsers } from "react-icons/fa6";
import { BiSolidCoupon } from "react-icons/bi";
import { MdNotificationsActive } from "react-icons/md";
import { TbListDetails } from "react-icons/tb";
import { MdSpaceDashboard } from "react-icons/md";
import Traffic from "Screens/Admin/Traffic/Traffic";
import ManagePromoCode from "Screens/Admin/Promocode/ManagePromoCode";
import Users from "Screens/Admin/Users";
import Coins from "Screens/Admin/Gifts_&_Coins/Coins";
import Gifts from "Screens/Admin/Gifts_&_Coins/Gifts";
import AccountDeleteReq from "Screens/Admin/AccountDeleteReq";
import BlockUser from "Screens/Admin/BulkNotification/BlockUser";
import Banner from "Screens/Admin/BulkNotification/Banner";
import UserDetailsPage from "Screens/Admin/UserDetailsPage";
import AdminProfilesDetails from "Screens/Admin/AdminProfilesDetails";
import { GiMoneyStack } from "react-icons/gi";
import ContactUs from "Screens/Admin/ContactUs/ContactUs";
import GroupRequest from "Screens/Admin/GroupRequest";
import CallHistories from "Screens/Admin/CallHistories/CallHistories";
import CoinHistories from "Screens/Admin/CoinHistories/CoinHistories";
import Avatar from "Screens/Admin/Avatar/Avatar";
import NameChangeReq from "Screens/Admin/NameChange/NameChangeReq";
import Approve from "Screens/Admin/Payout/Approve";
import WithdrawalRequest from "Screens/Admin/Payout/WithdrawalRequest";
import { VscRequestChanges } from "react-icons/vsc";
import Kyc from "Screens/Admin/Payout/Kyc";
import ManualWithdrawal from "Screens/Admin/Payout/ManualWithdrawal";
import Recharge from "Screens/Admin/Recharge/Recharge";
import StaffDashboard from "Screens/Admin/StaffDashboard/StaffDashboard";
import { GrUserWorker } from "react-icons/gr";
import Role from "Screens/Admin/RolePermission/Role";
import { loadDecrypted } from "./Common Usage/localStorageUtils";
import ComingSoon from "Common Usage/ComingSoon";
import GangTargets from "Screens/Admin/GangRankings/GangTargets";
import GangSummary from "Screens/Admin/GangRankings/GangSummary";
import GangLevelConfigPage from "Screens/Admin/GangLevelConfig/GangLevelConfigPage";
import BulkNotificationTable from "Screens/Admin/BulkNotification/BulkNotification";
import StaffActivityLog from "Screens/Admin/StaffActivity/StaffActivityLog";
import Masti from "Screens/Admin/Masti/Masti";
import CouponCode from "Screens/Admin/CouponCode/CouponCode";
import MilestoneConfigPage from "Screens/Admin/ActivityMilestoneConfig/MilestoneConfigPage";
import { IoMdTrophy } from "react-icons/io";
import { MdEvent } from "react-icons/md";
import EventManagement from "Screens/Admin/Events/EventManagement";
import AppVersionManager from "Screens/Admin/AppVersionManager";
import { MdSystemUpdate } from "react-icons/md";
import MessageHistory from "Screens/Admin/MessageHistory/MessageHistory";

const permissions = loadDecrypted("HeartConnect-Permissions");
const hasPermission = (key) => {
  if (key === "sign-in") return true;

  if (!key) return true;

  if (!permissions) return true;

  const parts = key.split(".");
  let node = permissions;

  for (let p of parts) {
    if (!node) return true;

    if (node.subModule && node.subModule[p]) {
      node = node.subModule[p];
    } else if (node[p]) {
      node = node[p];
    } else {
      return true;
    }
  }

  if (node?.permissions?.view === true) return true;

  return false;
};

const allRoutes = [
  {
    name: "Dashboard",
    showInSidebar: true,
    layout: "/admin",
    path: "dashboard",
    icon: <MdSpaceDashboard className="h-6 w-6" />,
    component: <MainDashboard />,
    clickable: true,
    permissionKey: "dashboard",
  },

  {
    name: "Staff Management",
    showInSidebar: true,
    layout: "/admin",
    path: "staff-management",
    icon: <GrUserWorker className="h-6 w-6" />,
    component: <StaffDashboard />,
    clickable: true,
    permissionKey: "roleManagement",
  },

  // {
  //   name: "Role",
  //   showInSidebar: true,
  //   layout: "/admin",
  //   path: "role",
  //   icon: <GrUserWorker className="h-6 w-6" />,
  //   component: <Role />,
  //   clickable: true,
  //   permissionKey: "roleManagement",
  // },

  // {
  //   name: "Staffs",
  //   showInSidebar: true,
  //   layout: "/admin",
  //   path: "staff-dashboard",
  //   icon: <GrUserWorker className="h-6 w-6" />,
  //   component: <StaffDashboard />,
  //   clickable: true,
  //   permissionKey: "staffManagement",
  // },

  {
    name: "Users",
    showInSidebar: true,
    layout: "/admin",
    findPath: "users",
    icon: <FaUsers className="h-6 w-6" />,
    clickable: false,
    permissionKey: "users",
    children: [
      {
        name: "User ",
        nestedFindPath: "user",
        layout: "/admin",
        path: "users/user",
        component: <Users />,
        permissionKey: "users.user",
      },
      {
        name: "Traffic",
        nestedFindPath: "traffic",
        layout: "/admin",
        path: "users/traffic",
        component: <Traffic />,
        permissionKey: "users.Traffic",
      },
      {
        name: "Call History",
        nestedFindPath: "call-history",
        layout: "/admin",
        path: "users/call-history",
        component: <CallHistories />,
        permissionKey: "users.CallHistory",
      },
      {
        name: "Message History",
        nestedFindPath: "message-history",
        layout: "/admin",
        path: "users/message-history",
        component: <MessageHistory />,
        permissionKey: "users.MessageHistory",
      },
      {
        name: "Coin History",
        nestedFindPath: "coin-histories",
        layout: "/admin",
        path: "users/coin-histories",
        component: <CoinHistories />,
        permissionKey: "users.CoinHistory",
      },
      {
        name: "Recharge",
        nestedFindPath: "recharge",
        layout: "/admin",
        path: "users/recharge",
        component: <Recharge />,
        permissionKey: "users.Recharge",
      },
      {
        name: "Avatar",
        nestedFindPath: "avatar",
        layout: "/admin",
        path: "users/avatar",
        component: <Avatar />,
        permissionKey: "users.Avatar",
      },
      {
        name: "BlockUser",
        nestedFindPath: "blockUser",
        layout: "/admin",
        path: "users/blockUser",
        component: <BlockUser />,
        permissionKey: "users.BlockUser",
      },
    ],
  },

  {
    name: "Pay Out",
    showInSidebar: true,
    layout: "/admin",
    findPath: "payout",
    icon: <GiMoneyStack className="h-6 w-6" />,
    clickable: false,
    permissionKey: "payout",
    children: [
      {
        name: "KYC",
        nestedFindPath: "kyc",
        layout: "/admin",
        path: "payout/kyc",
        component: <Kyc />,
        permissionKey: "payout.kyc",
      },
      {
        name: "Approve",
        nestedFindPath: "approve",
        layout: "/admin",
        path: "payout/approve",
        component: <Approve />,
        permissionKey: "payout.approve",
      },
      {
        name: "Wallet",
        nestedFindPath: "wallet",
        layout: "/admin",
        path: "payout/wallet",
        component: <WithdrawalRequest />,
        permissionKey: "payout.wallet",
      },
      {
        name: "Manual Withdrawal",
        nestedFindPath: "manual-withdrawal",
        layout: "/admin",
        path: "payout/manual-withdrawal",
        component: <ManualWithdrawal />,
        permissionKey: "payout.manualWithdrawal",
      },
    ],
  },

  {
    name: "Coin Management",
    showInSidebar: true,
    findPath: "coin-management",
    layout: "/admin",
    icon: <BiSolidCoupon className="h-6 w-6" />,
    clickable: false,
    permissionKey: "coinManagement",
    children: [
      {
        name: "Manage Coins",
        nestedFindPath: "manage-coins",
        layout: "/admin",
        path: "coin-management/manage-coins",
        component: <Coins />,
        permissionKey: "coinManagement.manageCoins",
      },
      {
        name: "Manage Emoji Gifts",
        nestedFindPath: "manage-gifts",
        layout: "/admin",
        path: "coin-management/manage-gifts",
        component: <Gifts />,
        permissionKey: "coinManagement.manageGifts",
      },
      {
        name: "Promo Code",
        nestedFindPath: "promocode",
        layout: "/admin",
        path: "coin-management/promocode",
        component: <ManagePromoCode />,
        permissionKey: "coinManagement.promocode",
      },
      {
        name: "Coin Promocode",
        nestedFindPath: "promo-code-usage",
        layout: "/admin",
        path: "coin-management/promo-code-usage",
        component: <PromoCodeUsage />,
        permissionKey: "coinManagement.coinPromocode",
      },
      {
        name: "Coupon Code",
        nestedFindPath: "coupon-code",
        layout: "/admin",
        path: "coin-management/coupon-code",
        component: <CouponCode />,
        permissionKey: "coinManagement.couponcode",
      },
    ],
  },

  {
    name: "Notification",
    showInSidebar: true,
    findPath: "notification",
    layout: "/admin",
    icon: <MdNotificationsActive className="h-6 w-6" />,
    clickable: false,
    permissionKey: "Notifications",
    children: [
      {
        name: "Single",
        nestedFindPath: "single",
        layout: "/admin",
        path: "notification/single",
        component: <ComingSoon />,
        permissionKey: "Notifications.single",
      },
      {
        name: "Bulk",
        nestedFindPath: "bulk",
        layout: "/admin",
        path: "notification/bulk",
        component: <BulkNotificationTable />,
        permissionKey: "Notifications.bulk",
      },
      {
        name: "Banner",
        nestedFindPath: "banner",
        layout: "/admin",
        path: "notification/banner",
        component: <Banner />,
        permissionKey: "Notifications.banner",
      },
    ],
  },

  {
    name: "User Request",
    showInSidebar: true,
    findPath: "user-request",
    layout: "/admin",
    icon: <VscRequestChanges className="h-6 w-6" />,
    clickable: false,
    permissionKey: "userRequests",
    children: [
      {
        name: "Account Delete Req",
        nestedFindPath: "acc-delete-req",
        layout: "/admin",
        path: "user-request/acc-delete-req",
        component: <AccountDeleteReq />,
        permissionKey: "userRequests.accDeleteReq",
      },
      {
        name: "Group Request",
        nestedFindPath: "group-request",
        layout: "/admin",
        path: "user-request/group-request",
        component: <GroupRequest />,
        permissionKey: "userRequests.groupReq",
      },
      {
        name: "Name Change Req",
        nestedFindPath: "name-change-req",
        layout: "/admin",
        path: "user-request/name-change-req",
        component: <NameChangeReq />,
        permissionKey: "userRequests.nameChangeReq",
      },
      {
        name: "Masti Request",
        nestedFindPath: "masti-req",
        layout: "/admin",
        path: "user-request/masti-req",
        component: <Masti />,
        permissionKey: "userRequests.masti",
      },
    ],
  },

  {
    name: "App Feedback",
    showInSidebar: true,
    layout: "/admin",
    path: "contact-us",
    icon: <RiContactsBookFill className="h-6 w-6" />,
    component: <ContactUs />,
    clickable: true,
    permissionKey: "appFeedback",
  },

  // Hidden Routes
  {
    name: "User Details",
    showInSidebar: false,
    layout: "/admin",
    path: "users/user-details/:id",
    component: <UserDetailsPage />,
    permissionKey: "user-details",
  },
  {
    name: "Admin Profile",
    showInSidebar: false,
    layout: "/admin",
    path: "my-profile",
    component: <AdminProfilesDetails />,
    permissionKey: "admin-profiles-details",
  },

  {
    name: "Gang Rankings",
    showInSidebar: true,
    findPath: "gang-rankings",
    layout: "/admin",
    icon: <VscRequestChanges className="h-6 w-6" />,
    clickable: false,
    permissionKey: "gangRankings",
    children: [
      {
        name: "Gang Targets",
        nestedFindPath: "gang-targets",
        layout: "/admin",
        path: "gang-rankings/gang-targets",
        component: <GangTargets />,
        permissionKey: "gangRankings.gangTarget",
      },
      {
        name: "Gang Summary",
        nestedFindPath: "gang-summary",
        layout: "/admin",
        path: "gang-rankings/gang-summary",
        component: <GangSummary />,
        permissionKey: "gangRankings.gangSummary",
      },
      {
        name: "Gang Level Config",
        nestedFindPath: "gang-level-config",
        layout: "/admin",
        path: "gang-rankings/gang-level-config",
        component: <GangLevelConfigPage />,
        permissionKey: "gangRankings.gangLevelConfig",
      },
    ],
  },
  {
    name: "Staff Activity",
    showInSidebar: true,
    layout: "/admin",
    path: "staff-activity",
    icon: <TbListDetails className="h-6 w-6" />,
    component: <StaffActivityLog />,
    clickable: true,
    permissionKey: "staffActivity",
  },

  // Auth
  {
    name: "Milestone Config",
    showInSidebar: true,
    layout: "/admin",
    path: "milestone-config",
    icon: <IoMdTrophy className="h-6 w-6" />,
    component: <MilestoneConfigPage />,
    clickable: true,
    permissionKey: "milestoneConfig",
  },

  {
    name: "Events",
    showInSidebar: true,
    layout: "/admin",
    path: "events",
    icon: <MdEvent className="h-6 w-6" />,
    component: <EventManagement />,
    clickable: true,
    permissionKey: "events",
  },

  {
    name: "App Version",
    showInSidebar: true,
    layout: "/admin",
    path: "app-version",
    icon: <MdSystemUpdate className="h-6 w-6" />,
    component: <AppVersionManager />,
    clickable: true,
    permissionKey: "appVersion",
  },

  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    component: <SignIn />,
    permissionKey: "sign-in",
  },
];

const routes = allRoutes
  .filter((route) => hasPermission(route.permissionKey))
  .map((route) => {
    if (route.children) {
      route.children = route.children.filter((child) =>
        hasPermission(child.permissionKey)
      );
    }
    return route;
  });

export default routes;
